module.exports = __webpack_public_path__ + "static/media/front-end.e491efcd.svg";